<template>
  <div class="q-pa-md">
    <div class="row col-12">
      <div style="width: 13%" class="column justify-around top">
        <q-img v-if="logo != null" :src="logo" />
        <q-img v-else src="../../../assets/MULTPEX_VETOR.png" />
      </div>
      <div class="column texto-header q-ml-xl">
        <span
          ><strong>Unidade de Entrega:</strong>
          {{ listaProdutos?.vendor?.name }}</span
        >
        <span><strong>Requisição Nº:</strong> {{ requisicaoId }}</span>
        <span
          ><strong>Requisitante:</strong>
          {{ listaProdutos.plantiff?.name }}</span
        >
        <span
          ><strong>Centro de Custo:</strong>
          {{
            `${listaProdutos.cost_center?.code} - ${listaProdutos.cost_center?.name}`
          }}</span
        >
        <span
          v-if="
            !$store.state.autenticacao.cliente.includes('cerradinho') &&
            !$store.state.autenticacao.cliente.includes('staging-cerradinho')
          "
          ><strong>Ordem de Serviço: </strong
          >{{ listaProdutos?.os?.numero }}</span
        >
        <span
          v-if="
            !$store.state.autenticacao.cliente.includes('cerradinho') ||
            !$store.state.autenticacao.cliente.includes('staging-cerradinho')
          "
          ><strong>Conta: </strong>{{ listaProdutos.cost_center?.conta }}</span
        >
        <span
          v-if="
            $store.state.autenticacao.cliente.includes('cerradinho') ||
            $store.state.autenticacao.cliente.includes('staging-cerradinho')
          "
          ><strong>Reserva: </strong>{{ reserva }}</span
        >
      </div>
    </div>
    <div class="row col-12">
      <span class="text-titulo q-mt-md q-mb-md">Itens do Voucher</span>
      <q-table
        class="col-12"
        :columns="columns"
        :rows="listaProdutos.products"
        hide-bottom
        flat
        dense
        hide-pagination
        :rows-per-page-options="[0]"
      >
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props">
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr>
            <q-td>
              <span>{{ props.row.code }}</span>
            </q-td>
            <q-td>
              <span>{{
                props.row?.contracts[0]?.pivot?.contract_product_description ||
                props.row.name
              }}</span>
            </q-td>
            <q-td>
              <span>{{ props.row.ca?.code }}</span>
            </q-td>
            <q-td>
              <div class="column">
                <span v-for="(lote, index) in props.row?.lotes" :key="index"
                  >Loc: {{ lote?.batch }} - Qtd: {{ lote?.amount }}</span
                >
              </div>
            </q-td>
            <q-td>
              <div class="column">
                <span v-for="(value, index) in props.row?.stock" :key="index">{{
                  value?.pivot?.address
                }}</span>
              </div>
            </q-td>
            <q-td>
              <span>{{ props.row.stock[0]?.measurement_unit }}</span>
            </q-td>
            <q-td>
              <span>{{ props.row.pivot?.amount }}</span>
            </q-td>
            <q-td>
              <span>{{
                converterParaReais(props.row.contracts[0]?.pivot?.price)
              }}</span>
            </q-td>
            <q-td>
              <span>{{
                converterParaReais(
                  parseInt(props.row.pivot?.amount) *
                    parseFloat(props.row.contracts[0]?.pivot?.price)
                )
              }}</span>
            </q-td>
          </q-tr>
        </template>
      </q-table>
      <div style="font-size: 14px" class="row col-12 justify-end">
        <span style="margin-right: 30px"
          ><span class="q-mr-lg">Total => </span>{{ valorTotal }}</span
        >
      </div>
    </div>
    <span class="row col-12 text-titulo q-mt-md q-mb-md"
      ><strong class="q-mr-xs">Comentários da Criação da Requisição:</strong>
      {{ listaProdutos?.description }}</span
    >
    <div class="separator"></div>
    <div class="row col-12 container-assinaturas">
      <div class="col-3 bloco-assinatura-esquerdo">
        <div
          v-if="historicoRequisicoes.retirada?.pivot"
          class="row col-12 justify-center"
        >
          <q-img
            v-if="
              historicoRequisicoes.retirada?.pivot?.auth_type == 'assinatura' ||
              historicoRequisicoes.retirada?.pivot?.auth_type == 'biometria'
            "
            fit="contain"
            class="imagem-autenticao"
            :src="historicoRequisicoes.retirada?.pivot?.auth_content"
          />
          <div v-else class="imagem-autenticao"></div>
        </div>
        <div v-else style="height: 50px"></div>
        <div style="border: 1px solid"></div>
        <div class="row col-12 justify-center">
          <div v-if="model?.status == 'Finalizado'">
            <strong>Retirado Por:</strong>
            {{ historicoRequisicoes.retirada?.pivot?.user?.name }}
          </div>

          <div v-else>
            <strong>Requisitante:</strong> {{ listaProdutos.plantiff?.name }}
          </div>
        </div>
        <div class="row col-12 justify-center">
          <div
            v-if="
              $store.state.autenticacao.cliente.includes('cerradinho') ||
              $store.state.autenticacao.cliente.includes('staging-cerradinho')
            "
          >
            <strong v-if="model?.status == 'Finalizado'"
              >MATRICULA:
              <span style="font-weight: normal">{{
                historicoRequisicoes.retirada?.pivot?.user?.sap
              }}</span></strong
            >
            <strong v-else
              >MATRICULA:
              <span style="font-weight: normal">{{
                listaProdutos.plantiff?.sap
              }}</span>
            </strong>
          </div>
          <div v-else>
            <strong v-if="model?.status == 'Finalizado'"
              >SAP:
              <span style="font-weight: normal">{{
                historicoRequisicoes.retirada?.pivot?.user?.sap
              }}</span>
            </strong>
            <strong v-else
              >SAP:
              <span style="font-weight: normal">{{
                listaProdutos.plantiff?.sap
              }}</span>
            </strong>
          </div>
        </div>
        <div class="row col-12 justify-center">
          <div>
            <strong>Autenticação:</strong>
          </div>
        </div>
      </div>

      <div
        v-if="historicoRequisicoes.aprovacao?.pivot"
        class="col-3 bloco-assinatura-direito"
      >
        <div class="row col-12 justify-center">
          <div class="imagem-autenticao"></div>
        </div>
        <div class="row col-12 justify-center">
          <div>
            <strong>Aprovado Por:</strong>
            {{ historicoRequisicoes.aprovacao?.pivot?.user?.name }} (SAP:
            {{ historicoRequisicoes.aprovacao?.pivot?.user?.sap }})
          </div>
        </div>
        <div class="row col-12 justify-center">
          <div>
            <strong>Aprovado Em:</strong>
            {{
              historicoRequisicoes.aprovacao?.pivot?.created_at
                ?.split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}
            {{
              historicoRequisicoes.aprovacao?.pivot?.created_at?.split(" ")[1]
            }}
          </div>
        </div>
      </div>
      <div v-else class="col-3 bloco-assinatura-direito">
        <div class="row col-12 justify-center">
          <div class="imagem-autenticao"></div>
        </div>
        <div class="row col-12 justify-center">
          <div>
            <strong>Aprovado Por:</strong>
            {{ historicoRequisicoes.aprovacao?.pivot?.user?.name }} (SAP:
            {{ historicoRequisicoes.aprovacao?.pivot?.user?.sap }})
          </div>
        </div>
        <div class="row col-12 justify-center">
          <div>
            <strong>Aprovado Em:</strong>
            {{
              historicoRequisicoes.aprovacao?.pivot?.created_at
                ?.split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}
            {{
              historicoRequisicoes.aprovacao?.pivot?.created_at?.split(" ")[1]
            }}
          </div>
        </div>
      </div>
    </div>
    <span
      v-if="
        ($store.state.autenticacao.cliente.includes('staging-pg') ||
          $store.state.autenticacao.cliente.includes('pg')) &&
        model?.status == 'Finalizado'
      "
      class="row text-h6 col-12 justify-center q-mt-lg q-mb-md"
      ><strong class="q-mr-xs">Termo de compromisso </strong>
    </span>
    <span
      v-if="
        ($store.state.autenticacao.cliente.includes('staging-pg') ||
          $store.state.autenticacao.cliente.includes('pg')) &&
        model?.status == 'Finalizado'
      "
      >Recebi gratuitamente, em perfeito estado novo(s), o(s) equipamento(s) de
      proteção individual EPI(s) contido(s) neste recibo.<br />
      Declaro ter sido treinado pelo Serviço Especializado de Segurança e
      Medicina do Trabalho desta empresa, quanto ao uso correto deste(s) EPI(s)
      e orientado para cumprimento das seguintes regras:<br />
      1-) Usar o(s) EPI(s) recebido(s) sempre que for(em) exigido(s) pelo
      contato a a gentes agressivos ou atividade por mim exercida e em
      conformidade com as norma de SEGURANÇA DO TRABALHO.<br />
      2-) Limpar, Guardar e conservar o(s) EPI(s) por mim recebido(s), sendo
      esta obrigação de minha inteira e pessoal responsabilidade.<br />
      3-) Comunicar de imediato ao Setor de segurança as alterações sofridas
      pelo(s) EPI(s), que por acidente, quer por uso habitual, para que seja(m)
      reparados(s) ou substituido(s).<br />
      4-) Devolver o(s) EPI(s) à Empresa sempre que solicitado, sendo certo que
      a não devolução acarretará o pagamento do(s) mesmo(s).<br />
      ESTOU CIENTE DE QUE RECUSA INJUSTIFICAVEL EM USAR O(S) EPI(S) E NÃO
      CUMPRIMENTO DAS INSTRUÇÕES DA EMPRESA CONSTITUI ATO FALTOSO.<br
    /></span>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

const columns = [
  { name: "codigo", label: "Código", align: "left" },
  { name: "produto", label: "Produto", align: "left" },
  { name: "ca", label: "CA", align: "left" },
  { name: "localizacoes", label: "Localizações", align: "left" },
  { name: "address", label: "Endereço", align: "left" },
  { name: "unidade", label: "Unidade", align: "left" },
  { name: "quantidade", label: "Quantidade", align: "left" },
  { name: "unitario", label: "Unitário", align: "left" },
  { name: "total", label: "Total", align: "left" },
];

export default {
  setup() {
    const store = useStore();
    const route = useRoute();
    const model = ref();
    const requisicaoId = route.params.requisicaoId;
    const listaProdutos = ref([]);
    const valorTotal = ref(0);
    const reserva = ref("");
    const logo = ref(null);
    const historicoRequisicoes = ref({ retirada: {}, aprovacao: {} });

    const detalharVoucher = async () => {
      store.dispatch("pdt/hiddenHeader", false);
      try {
        const response = await store.dispatch(
          "requisicao/buscarDetalheRequisicao",
          {
            reqId: requisicaoId,
          }
        );
        model.value = response.data.model;
        listaProdutos.value = response.data.model;
        receberHistoricoRequisicao(listaProdutos.value.applications);
        let valorTotalProdutos = 0;
        listaProdutos.value.products.forEach((valorAtual) => {
          if (
            valorAtual.pivot?.amount != null &&
            valorAtual.contracts[0]?.pivot?.price != null
          ) {
            valorTotalProdutos +=
              parseInt(valorAtual.pivot?.amount) *
              parseFloat(valorAtual.contracts[0]?.pivot?.price).toFixed(2);
          }
        });
        logo.value = response.data.model.vendor.logo;
        valorTotal.value = converterParaReais(valorTotalProdutos);
        reserva.value = listaProdutos.value?.products[0]?.reserva_sap;
        if (model.value.status == "Finalizado") {
          const fichaDados = await store.dispatch("requisicao/fichaEPI", {
            voucher_id: requisicaoId,
          });

          listaProdutos.value.products = listaProdutos.value.products.map(
            (produto) => {
              const produtoFichaEspecifico = fichaDados.data.return.data.find(
                (ficha) => {
                  return produto.id == ficha.ItemId;
                }
              );

              return produtoFichaEspecifico == undefined
                ? produto
                : {
                    ...produto,
                    code: produtoFichaEspecifico?.ItemCodigo,
                    pivot: {
                      user: { name: produtoFichaEspecifico?.ItemNomeContrato },
                      product_id: produtoFichaEspecifico?.ItemId,
                      amount:
                        Number(
                          produtoFichaEspecifico?.ItemQuantidade?.replace(
                            /\./g,
                            ""
                          ).replace(",", ".")
                        ) || 0,
                      new_amount:
                        Number(
                          produtoFichaEspecifico?.ItemQuantidade?.replace(
                            /\./g,
                            ""
                          ).replace(",", ".")
                        ) || 0,
                    },
                    name: produtoFichaEspecifico?.ItemNomeContrato,
                    ca: { code: produtoFichaEspecifico?.ItemCaCodigo },
                    grupoProduto: produtoFichaEspecifico?.ItemGrupoNome,
                    contracts: [
                      {
                        pivot: {
                          price:
                            Number(
                              produtoFichaEspecifico?.ItemPreco?.replace(
                                /\./g,
                                ""
                              ).replace(",", ".")
                            ) || 0,
                        },
                      },
                    ],
                    quantidade:
                      Number(
                        produtoFichaEspecifico?.ItemQuantidade?.replace(
                          /\./g,
                          ""
                        ).replace(",", ".")
                      ) || 0,
                  };
            }
          );
        }
        console.log(listaProdutos.value.products);
      } catch (error) {
        console.log(error);
      }
    };

    const converterParaReais = (valor) => {
      if (valor == null || isNaN(valor)) {
        return "";
      }
      let valorFormatado = parseFloat(valor).toFixed(2);
      valorFormatado = valorFormatado.replace(/\d(?=(\d{3})+\.)/g, "$&,");
      valorFormatado = "R$ " + valorFormatado;

      return valorFormatado;
    };

    const receberHistoricoRequisicao = (dados) => {
      dados.forEach((dado) => {
        if (dado.name == "Retirado por") {
          historicoRequisicoes.value.retirada = dado;
        }
        if (dado.name == "Aprovação") {
          historicoRequisicoes.value.aprovacao = dado;
        }
      });
    };

    onMounted(detalharVoucher);

    return {
      columns,
      detalharVoucher,
      requisicaoId,
      listaProdutos,
      converterParaReais,
      valorTotal,
      historicoRequisicoes,
      receberHistoricoRequisicao,
      reserva,
      model,
      logo,
    };
  },
};
</script>

<style scoped>
.texto-header {
  font-size: 17px;
}
tbody tr td {
  white-space: pre-wrap;
}
.text-titulo {
  font-size: 16px;
  font-weight: bold;
}
.separator {
  border-bottom: 1px solid #707070;
}
.container-assinaturas {
  margin-top: 80px;
  display: flex;
  justify-content: space-between;
}
.bloco-assinatura-esquerdo {
  margin-left: 60px;
}
.bloco-assinatura-direito {
  margin-right: 60px;
}
.imagem-autenticao {
  height: 140px;
  width: 230px;
}

@media print {
  .texto-header {
    font-size: 13px;
  }
  .text-titulo {
    font-size: 14px;
    font-weight: bold;
  }
  .container-assinaturas {
    display: flex;
    justify-content: center;
  }
  .bloco-assinatura-esquerdo {
    margin-right: 60px;
  }
  .bloco-assinatura-direito {
    margin-left: 60px;
  }
  .imagem-autenticao {
    height: 100px;
    width: 180px;
  }
}
</style>
